import { Injectable, computed, signal } from '@angular/core';
import { MonoTypeOperatorFunction, defer, finalize } from 'rxjs';

/** Drives the app-wide full-screen loader rendered in AppComponent. */
@Injectable({ providedIn: 'root' })
export class LoaderService {
  private readonly pending = signal(0);

  readonly active = computed(() => this.pending() > 0);

  show(): void {
    this.pending.update((n) => n + 1);
  }

  hide(): void {
    this.pending.update((n) => Math.max(0, n - 1));
  }

  /** Shows the loader for the lifetime of the observable: `source$.pipe(loader.track())`. */
  track<T>(): MonoTypeOperatorFunction<T> {
    return (source) =>
      defer(() => {
        this.show();
        return source.pipe(finalize(() => this.hide()));
      });
  }
}
